var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import Fade from "../../Utilities/Fade";
export const NavHeading = (_a) => {
    var { isOpen = true } = _a, props = __rest(_a, ["isOpen"]);
    return (React.createElement(React.Fragment, null,
        props.break && React.createElement("hr", { className: "navbar-divider my-2" }),
        React.createElement(Fade, { in: isOpen, timeout: 150, className: "navbar-heading", "data-testid": props.testId, HtmlTag: "h6" }, props.children)));
};
//# sourceMappingURL=NavHeading.js.map